"use client";

import React from "react";
import { Shield, UserCheck, DoorClosed, Lightbulb } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commitments = [{
  title: "Flexible Working Hours",
  description: "We understand the importance of work-life balance in healthcare. Our scheduling team works closely with you to create a shift pattern that fits your personal commitments, whether you prefer morning, evening, or weekend rotations.",
  icon: DoorClosed
}, {
  title: "Career Progression Paths",
  description: "At Cynthylee Health Care, we invest in your future. We provide fully funded training, NVQ certifications, and clear pathways for advancement into senior care, management, or specialized clinical roles within our Brighton team.",
  icon: UserCheck
}, {
  title: "Comprehensive Pension Scheme",
  description: "Your long-term security matters to us. We offer a competitive workplace pension scheme with generous employer contributions, ensuring that while you care for others today, your own future is well-protected and supported.",
  icon: Shield
}, {
  title: "Supportive Team Culture",
  description: "Join a community of compassionate professionals who value mutual respect and collaboration. We host regular team-building events and provide 24/7 clinical support to ensure you never feel alone while delivering care.",
  icon: Lightbulb
}];
export default function OurCommitmentToYou() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222818" id="why-work-with-us" className="bg-background text-foreground py-12 md:py-16 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start">
          
          {}
          <div ref={headerRef} className={`lg:col-span-5 lg:sticky lg:top-32 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-secondary text-secondary-foreground text-sm font-medium mb-6">
              <Shield className="size-4" />
              <span>Join Our Brighton Team</span>
            </div>
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight tracking-tight mb-6">
              Why Work With Cynthylee Health Care?
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed font-sans">
              We believe that exceptional care starts with exceptional caregivers. By joining our CQC-registered team, you become part of a premium healthcare provider dedicated to excellence, compassion, and professional growth.
            </p>
          </div>

          {}
          <div ref={accordionRef} className={`lg:col-span-7 transition-all duration-1000 delay-200 ease-out ${isAccordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Accordion type="single" collapsible className="w-full space-y-2">
              {commitments.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border-t-4 border-t-primary/40 border-x border-b border-border rounded-xl px-6 py-2 shadow-md data-[state=open]:shadow-lg transition-all duration-300">
                  <AccordionTrigger className="hover:no-underline py-4">
                    <div className="flex items-center gap-4 text-left">
                      <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-ring shrink-0">
                        <item.icon className="size-5" />
                      </div>
                      <span className="font-default text-lg font-semibold text-foreground">
                        {item.title}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed pl-14 pb-6 font-sans">
                    {item.description}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

        </div>
      </div>
    </section>;
}